export default __webpack_public_path__ + "static/media/inne_miesa.cfc47b0f.svg";